export const AmplitudeEvent = {
  // APP
  APP_LOGGED_IN: 'App start: Logged in',
  // DEVX
  DEVX_SANDBOX_DEVELOPER_LOGGED_IN: 'DevX : SB: Action - Developer Logged in',
  DEVX_SANDBOX_CLICKED_GO_LIVE: 'DevX: SB: Click - Clicked Go Live',
  DEVX_SANDBOX_CLICKED_GENERATE_API_KEY: 'DevX: SB: Click - Generate API Keys button',
  DEVX_SANDBOX_CLICKED_READ_DOCS: 'DevX: SB: Click - Read docs',
  DEVX_SANDBOX_CLICKED_READ_API_REF: 'DevX: SB: Click - Read API reference',
  DEVX_SANDBOX_CLICKED_VIEW_WALLETS: 'DevX: SB: Click - View wallets',
  DEVX_SANDBOX_CLICKED_LEARN_ABOUT_WALLETS: 'DevX: SB: Click - Learn more about wallets',
  DEVX_SANDBOX_CLICKED_CREATE_MERCHANT: 'DevX: SB: Click - Create a Merchant',
  DEVX_SANDBOX_CLICKED_MERCHANT_LEARN_MORE: 'DevX: SB: Click - Learn more about on Merchant page',
  DEVX_SANDBOX_CLICKED_CREATE_PAYMENT: 'DevX: SB: Click - Create a Payment',
  DEVX_SANDBOX_CLICKED_CONTACT_SALES: 'DevX: SB: Click - Contact Sales team',
  // ONBOARDING
  ONBOARDING_LOAD_CTA_GET_STARTED: 'ONB - Page Load - CTA Get Started',
  ONBOARDING_CLICK_CONTINUE_CTA_GET_STARTED: 'ONB - Continue - CTA Get Started',
  ONBOARDING_CONFIRM_EMAIL: 'ONB - Confirmed email',
  ONBOARDING_CLICK_RESEND_EMAIL_VERIFICATION: 'ONB - Resend email verification code',
  // HOMEPAGE
  HOMEPAGE_TOTAL_USERS: 'HOME - Total users',
  HOMEPAGE_CLICK_MERCHANT_DETAILS: 'HOME - Add merchant details',
  HOMEPAGE_CLICK_CREATE_PAYMENT: 'HOME - Create Payment',
  HOMEPAGE_CLICK_VIEW_ALL_WALLETS: 'HOME - View all wallets',
  HOMEPAGE_CLICK_GENERATE_API_KEYS: 'HOME - Generate API keys',
  // MANAGE ACOUNT (SETTINGS)
  MANAGE_ACCOUNT_BANK_ACCOUNT_ADDED: 'Bank Account account added',

  // VERSION 2 EVENTS (REWORK)

  // DASHBOARD (HOMEPAGE)
  DASHBOARD_HOME: 'Dashboard: Home',

  // DEVX (HOMEPAGE)
  DEVX_HOME: 'DevX: Home',

  // WALLETS
  WALLET_HOME: 'Wallet: Home',
  WALLET_POPOVER_MENU: 'Wallet: Popover Menu',
  WALLET_INITIATE: 'Create Wallet: Initiate',
  EOF_INITIATE_WALLET_SUCCESS: 'EOF Create Wallet: Success',
  EOF_INITIATE_WALLET_ERROR: 'EOF Create Wallet: Error',

  // WALLET DETAILS
  WALLET_DETAILS: 'Wallet: Wallet Details',
  WALLET_DETAILS_PAY: 'Wallet Details: Pay',
  WALLET_DETAILS_WITHDRAW: 'Wallet Details: Withdraw',
  WALLET_DETAILS_DEPOSIT: 'Wallet Details: Deposit',
  WALLET_DETAILS_CONVERT: 'Wallet Details: Convert',
  WALLET_DETAILS_SEND: 'Wallet Details: Send',
  WALLET_DETAILS_TRANSACTION: 'Wallet Details: Transaction History',

  // TRANSACTION HISTORY
  TRANSACTION_HISTORY_HOME: 'Transaction History: Home',

  // PAY
  PAY_INITIATE: 'Pay: Initiate',
  PAY_INPUT_AMOUNT: 'Pay: Input Amount',
  PAY_CONFIRM: 'Pay: Confirm',
  PAY_SUCCESS: 'EOF Pay: Success',
  PAY_REQUEST: 'Pay: Request',

  // Fiat payouts
  FIAT_PAYOUT_INITIATE: 'Fiat Payout: Initiate',
  FIAT_PAYOUT_CLOSE: 'Fiat Payout: Close',
  FIAT_PAYOUT_BENEFICIARY: 'Fiat Payout: Beneficiary',
  FIAT_PAYOUT_BENEFICIARY_ADD: 'Fiat Payout: Add Beneficiary',
  FIAT_PAYOUT_SELECT_BENEFICIARY: 'Fiat Payout: Select Beneficiary',
  FIAT_PAYOUT_DETAILS: 'Fiat Payout: Details',
  FIAT_PAYOUT_DETAILS_CONTINUE: 'Fiat Payout: Details Continue',
  FIAT_PAYOUT_CONFIRMATION: 'Fiat Payout: Confirm',
  FIAT_PAYOUT_CONFIRMATION_SUBMIT: 'Fiat Payout: Confirm Submit',
  FIAT_PAYOUT_CANCEL: 'Fiat Payout: Cancel',
  FIAT_PAYOUT_ERROR: 'Fiat Payout: Error',
  FIAT_PAYOUT_EOF: 'EOF Fiat Payout',
  FIAT_PAYOUT_UPDATE_BENEFICIARY: 'Fiat Payout: Update Beneficiary',

  // WITHDRAW
  WITHDRAW_INITIATE: 'Withdraw: Initiate',
  WITHDRAW_CONFIRM: 'Withdraw: Confirm',
  WITHDRAW_SUCCESS: 'EOF Withdraw: Success',
  WITHDRAW_REQUEST: 'Withdraw: Request',

  // DEPOSIT
  DEPOSIT_INITIATE: 'Deposit: Initiate',
  DEPOSIT_COPY: 'Deposit: Copy',
  EOF_DEPOSIT_SUCCESS: 'EOF Deposit: Success',

  // MANAGE ACCOUNT
  MANAGE_ACCOUNT: 'Manage Account: Home',
  MANAGE_ACCOUNT_MANAGE_CRYPTO_ADDRESSES: 'Manage Account: Manage Crypto Addresses',

  // APPROVALS
  APPROVALS_HOME: 'Approvals: Home',
  UPDATE_APPROVALS_PREFERENCE: 'Approvals: Update Preference',
  MANAGE_APPROVERS_INITIATE: 'Manage Approvers: Initiate',
  EOF_MANAGE_APPROVERS_SUCCESS: 'EOF Manage Approvers: Success',
  EOF_MANAGE_APPROVERS_ERROR: 'EOF Manage Approvers: Error',
  APPROVE_TRANSACTION_INITIATE: 'Approve Transaction: Initiate',
  EOF_APPROVE_TRANSACTION_SUCCESS: 'EOF Approve Transaction: Success',
  EOF_APPROVE_TRANSACTION_ERROR: 'EOF Approve Transaction: Error',
  REJECT_TRANSACTION_INITIATE: 'Reject Transaction: Initiate',
  EOF_REJECT_TRANSACTION_SUCCESS: 'EOF Reject Transaction: Success',
  EOF_REJECT_TRANSACTION_ERROR: 'EOF Reject Transaction: Error',

  // ADD CRYPTO ADDRESS WHITELIST
  ADD_CRYPTO_ADDRESS_WHITELIST_INITIATE: 'Add Crypto Address Whitelist: Initiate',
  ADD_CRYPTO_ADDRESS_WHITELIST_CONFIRM: 'Add Crypto Address Whitelist: Confirm',
  EOF_ADD_CRYPTO_ADDRESS_WHITELIST_SUCCESS: 'EOF Add Crypto Address Whitelist: Success',

  // DELETE CRYPTO ADDRESS WHITELIST
  DELETE_CRYPTO_ADDRESS_WHITELIST_INITIATE: 'Delete Crypto Address Whitelist: Initiate',
  EOF_DELETE_CRYPTO_ADDRESS_WHITELIST_SUCCESS: 'EOF Delete Crypto Address Whitelist: Success',

  // MANAGE TEAM MEMBERS
  MANAGE_TEAM_MEMBERS: 'Manage Account: Manage Team members',
  ADD_TEAM_MEMBER_INITIATE: 'Add Team member: Initiate',
  EDIT_TEAM_MEMBER_INITIATE: 'Edit Team member: Initiate',
  EOF_EDIT_TEAM_MEMBER_SUCCESS: 'Edit Team member: Success',
  EOF_ADD_TEAM_MEMBER_SUCCESS: 'EOF Add Team member: Success',
  EOF_ADD_TEAM_MEMBER_ERROR: 'EOF Add Team member: Error',
  EOF_TOGGLE_TEAM_MEMBER_APPROVER_SUCCESS: 'EOF Toggle Team member Approver Role: Success',
  EOF_TOGGLE_TEAM_MEMBER_APPROVER_ERROR: 'EOF Toggle Team member Approver Role: Error',

  // MANAGE BENEFICIARIES
  MANAGE_BENEFICIARIES: 'Manage Account: Manage Beneficiaries',

  // ADD BENEFICIARY
  ADD_BENEFICIARY_SELECT_DESTINATION: 'Add Beneficiary: Select Destination',
  ADD_BENEFICIARY_INITIATE: 'Add Beneficiary: Initiate',
  ADD_BENEFICIARY_CONFIRM: 'Add Beneficiary: Confirm',
  EOF_ADD_BENEFICIARY_SUCCESS: 'EOF Add Beneficiary: Success',

  // DELETE BENEFICIARY
  DELETE_BENEFICIARY_INITIATE: 'Delete Beneficiary: Initiate',
  EOF_DELETE_BENEFICIARY_SUCCESS: 'EOF Delete Beneficiary: Success',

  // MASS PAYOUTS
  MASS_PAYOUTS: 'Mass Payouts: Home',
  MASS_PAYOUTS_INITIATE: 'Mass Payouts: Initiate',
  MASS_PAYOUTS_CONFIRM: 'Mass Payouts: Confirm',
  EOF_MASS_PAYOUTS_SUCCESS: 'EOF Mass Payouts: Success',
  EOF_MASS_PAYOUTS_ERROR: 'EOF Mass Payouts: Error',

  // CUSTOMERS
  CUSTOMERS: 'Customers: Home',
  ADD_NEW_CUSTOMER: 'Customers: Add New Customer',
  CUSTOMER: 'Customer: Home',

  // PAYMENT LINKS
  PAYMENTS: 'Payments Home',
  PAYMENT_INITIATE: 'Create Payment: Initiate',
  EOF_PAYMENT: 'EOF Create Payment: Success',
  EOF_PAYMENT_ERROR: 'EOF Create Payment: Error',

  //CHANNELS
  CHANNELS: 'Channels: Home',
  CHANNEL_VIEW_DETAILS: 'Channels: View Details',
  CHANNEL_INITIATE: 'Create Channel: Initiate',
  EOF_CHANNEL: 'EOF Create Channel: Success',
  EOF_CHANNEL_ERROR: 'EOF Create Channel: Error',
  CHANNEL_EDIT_INITIATE: 'Edit Channel: Initiate',
  EOF_EDIT_CHANNEL: 'EOF Edit Channel: Success',
  EOF_EDIT_CHANNEL_ERROR: 'EOF Edit Channel: Error',
  MANAGE_CHANNEL: 'Manage Account: Manage Channels',

  //MANAGE API KEYS
  MANAGE_API_KEYS: 'Manage Account: Manage API Keys',
  API_KEY_INITIATE: 'Create API Key: Initiate',
  EOF_INITIATE_API_KEY_SUCCESS: 'EOF Create API Key: Success',
  API_KEY_EDIT: 'Edit API Key: Initiate',
  EOF_EDIT_API_KEY_SUCCESS: 'EOF Edit API Key: Success',
  DELETE_API_KEY_INITIATE: 'Delete API Key: Initiate',
  EOF_DELETE_API_KEY_SUCCESS: 'EOF Delete API Key: Success',

  //MANAGE MERCHANTS
  MANAGE_MERCHANTS: 'Manage Account: Manage Merchants',
  MERCHANT_INITIATE: 'Create Merchant: Initiate',
  EOF_INITIATE_MERCHANT_SUCCESS: 'EOF Create Merchant: Success',
  EOF_INITIATE_MERCHANT_ERROR: 'EOF Create Merchant: Error',
  MERCHANT_EDIT: 'Edit Merchant: Initiate',
  EOF_EDIT_MERCHANT_SUCCESS: 'EOF Edit Merchant: Success',
  EOF_EDIT_MERCHANT_ERROR: 'EOF Edit Merchant: Error',

  //EXPORT TRANSACTIONS
  EXPORT_TRANSACTION_INITIATE: 'Export Transaction: Initiate',
  EOF_CREATE_EXPORT_INITIATE_SUCCESS: 'EOF: Create Export Initiate: Success',
  EOF_CREATE_EXPORT_INITIATE_ERROR: 'EOF: Create Export Initiate: Error',
  EDIT_EXPORT_INITIATE: 'Edit Export: Initiate',
  EOF_EDIT_EXPORT_INITIATE_SUCCESS: 'EOF: Edit Export Initiate: Success',
  EOF_EDIT_EXPORT_INITIATE_ERROR: 'EOF: Edit Export Initiate: Error',
  EOF_DELETE_EXPORT_SUCCESS: 'EOF: Delete Export: Success',
  EOF_DELETE_EXPORT_ERROR: 'EOF: Delete Export: Error',

  // PREFERENCES
  UPDATE_THEME_PREFERENCE: 'Theme: Update Preferences',

  // REWARDS
  REWARDS_HOME: 'Rewards: Home',
  REWARDS_DETAILS: 'Rewards: Details',
  REWARDS_ALLOCATE_FUNDS_INITIATE: 'Rewards Allocate Funds Initiate',
  REWARDS_ALLOCATE_FUNDS_CANCEL: 'EOF: Rewards Allocate Funds Cancel',
  REWARDS_ALLOCATE_FUNDS_SUCCESS: 'EOF: Rewards Allocate Funds Success',
  REWARDS_ALLOCATE_FUNDS_ERROR: 'EOF: Rewards Allocate Funds Error',
  Rewards_ALLOCATE_FUNDS_CREATE_PORTFOLIO_SUCCESS:
    'Rewards: Allocate Funds Create Portfolio Success',
  Rewards_ALLOCATE_FUNDS_CREATE_PORTFOLIO_ERROR: 'Rewards: Allocate Funds Create Portfolio Error',
  REWARDS_WITHDRAW_FUNDS_INITIATE: 'Rewards Withdraw Funds Initiate',
  REWARDS_WITHDRAW_FUNDS_CANCEL: 'EOF: Rewards Withdraw Funds Cancel',
  REWARDS_WITHDRAW_FUNDS_SUCCESS: 'EOF: Rewards Withdraw Funds Success',
  REWARDS_WITHDRAW_FUNDS_ERROR: 'EOF: Rewards Withdraw Funds Error',
  REWARDS_REMOVE_ALLOCATION_INITIATE: 'Rewards Remove Allocation Initiate',
  REWARDS_REMOVE_ALLOCATION_CANCEL: 'EOF: Rewards Remove Allocation Cancel',
  REWARDS_REMOVE_ALLOCATION_SUCCESS: 'EOF: Rewards Remove Allocation Success',
  REWARDS_REMOVE_ALLOCATION_ERROR: 'EOF: Rewards Remove Allocation Error',

  // EARN
  EARN_HOME: 'Earn: Home',
  EARN_DETAILS: 'Earn: Details',
  EARN_DEPOSIT_INITIATE: 'Earn Deposit Initiate',
  EARN_DEPOSIT_CANCEL: 'EOF: Earn Deposit Cancel',
  EARN_DEPOSIT_SUCCESS: 'EOF: Earn Deposit Success',
  EARN_DEPOSIT_ERROR: 'EOF: Earn Deposit Error',
  EARN_CREATE_PORTFOLIO_SUCCESS: 'Earn: Deposit Create Portfolio Success',
  EARN_CREATE_PORTFOLIO_ERROR: 'Earn: Deposit Create Portfolio Error',
  EARN_WITHDRAW_INITIATE: 'Earn Withdraw Initiate',
  EARN_WITHDRAW_CANCEL: 'EOF: Earn Withdraw Cancel',
  EARN_WITHDRAW_SUCCESS: 'EOF: Earn Withdraw Success',
  EARN_WITHDRAW_ERROR: 'EOF: Earn Withdraw Error',
  EARN_DISTRIBUTE_INITIATE: 'Earn Distribute Initiate',
  EARN_DISTRIBUTE_CANCEL: 'EOF: Earn Distribute Cancel',
  EARN_DISTRIBUTE_SUCCESS: 'EOF: Earn Distribute Success',
  EARN_DISTRIBUTE_ERROR: 'EOF: Earn Distribute Error',

  //CONVERT
  CONVERT_INITIATE: 'Convert: Initiate',
  CONVERT_REQUEST_QUOTE: 'Convert: Request Quote',
  EOF_CONVERT_REQUEST_QUOTE_ERROR: 'Convert: Request Quote Error',
  CONVERT_ACCEPT_QUOTE: 'Convert: Accept Quote',
  EOF_CONVERT_ACCEPT_QUOTE_ERROR: 'Convert: Accept Quote Error',
  CONVERT_REFRESH_QUOTE: 'Convert: Refresh Quote',
  EOF_CONVERT_REFRESH_QUOTE_ERROR: 'Convert: Refresh Quote Error',
  EOF_CONVERT_SUCCESS: 'EOF: Convert: Success',
  EOF_CONVERT_EXIT: 'EOF: Convert: Exit',
  EOF_CONVERT_BACK: 'EOF: Convert: Back',

  // PAYMENT LIMITS
  EOF_PAYMENT_LIMIT_CREATE_SUCCESS: 'EOF Create Payment Limit: Success',
  EOF_PAYMENT_LIMIT_CREATE_ERROR: 'EOF Create Payment Limit: Error',
  EOF_PAYMENT_LIMIT_UPDATE_SUCCESS: 'EOF Update Payment Limit: Success',
  EOF_PAYMENT_LIMIT_UPDATE_ERROR: 'EOF Update Payment Limit: Error',
} as const

export type AmplitudeEventType = (typeof AmplitudeEvent)[keyof typeof AmplitudeEvent]

export const AmplitudeEventCategory = {
  APPLICATION: 'Application',
  MERCHANT_PORTAL: 'Merchant Portal',
  MANAGE_CRYPTO_ADDRESS: 'Manage Crypto Address',
  ONBOARDING: 'Onboarding',
  WALLET: 'Wallet',
  WALLET_TRANSACTION_EXPORT: 'WalletTransactionExport',
  WALLET_TRANSACTION_SEARCH: 'Wallet Transaction Search',
  WALLET_SEARCH_TRANSACTION_MODAL: 'Wallet Transaction Search Modal',
  WALLET_SEARCH_TRANSACTION_SIDE_PANEL: 'Wallet Transaction Search Side Panel',
} as const

export const AmplitudeEventAction = {
  LOAD: 'load',
  NAVIGATE: 'navigate',
  COPY: 'copy',
  CLICK: 'click',
  SEARCH: 'search',
  VERIFIED: 'verified',
  WHITELIST: 'whitelist',
  ERROR: 'error',
  VIEW: 'view',
  REFRESH: 'refresh',
} as const
